/**
 * Sehr kleiner Hash-Router.
 *
 * Bewusst kein Router-Paket: die Anwendung hat eine Handvoll Seiten, und
 * `#/kunden/<id>` funktioniert ohne jede Server- oder Traefik-Regel für
 * History-Fallbacks. Ein Umstieg auf Pfad-Routing bliebe später möglich.
 */

function ausHash(): string {
  const hash = location.hash.replace(/^#/, '');
  return hash === '' ? '/' : hash;
}

class Router {
  pfad = $state(ausHash());

  constructor() {
    addEventListener('hashchange', () => {
      this.pfad = ausHash();
      // Nach einem Seitenwechsel oben anfangen – sonst landet man auf der
      // Kundenmaske mitten im Dokument.
      scrollTo({ top: 0 });
    });
  }

  /** Zerlegt den Pfad in Segmente: '/kunden/abc' → ['kunden', 'abc'] */
  get segmente(): string[] {
    return this.pfad.split('/').filter(Boolean);
  }
}

export const router = new Router();

export function geheZu(pfad: string): void {
  location.hash = pfad;
}
